// extracted by mini-css-extract-plugin
export var growableInput = "_85-0";
export var tagContainer = "_85-2";
export var textInput = "_85-1";